import { queryOptions } from '@tanstack/react-query';

import { api } from '@/lib/api/api';
import type { AgentBrokerListParams } from '@/lib/api/domains/agents-brokers';
import type { AgentBrokerId } from '@/lib/api/ids';
import { keys } from '@/lib/query-keys';

/** Consumption layer for agents/brokers (mirrors providers'/clients' shape). */
export function agentBrokerListQuery(params: AgentBrokerListParams) {
  return queryOptions({
    queryKey: keys.agentsBrokers.list(params),
    queryFn: () => api.agentsBrokers.list(params),
    staleTime: 30_000,
  });
}

export function agentBrokerDetailQuery(agentBrokerId: AgentBrokerId) {
  return queryOptions({
    queryKey: keys.agentsBrokers.detail(agentBrokerId),
    queryFn: () => api.agentsBrokers.get(agentBrokerId),
    staleTime: 30_000,
  });
}
